// extracted by mini-css-extract-plugin
module.exports = {"containerMenu":"style_containerMenu__2XoXG"};